import React from 'react';
import { NavLink } from 'react-router-dom';
import { Menu } from '@headlessui/react';
import CargomaticLogo from 'img/cargomatic-logo-dark.png';
import SessionStore from 'stores/SessionStore';
import TrackingHeader from 'components/ui/tracking-header';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import classNames from 'classnames';
import { getCustomerReports } from 'utils/UnifiedViewWebAPIUtils';
import Navbar from '../v2/navs/Navbar';
import DropdownMenu from '../v2/dropdowns/DropdownMenu';
import UserActionCreators from '../../actions/UserActionCreators';
import WhiteLabel from '../../utils/whitelabel.js';
import NavbarOverlayBanner from '../v2/navbar-overlay-banner';
import ShipmentSearch from './shipment-search';
import { Avatar } from '../modules/user/Avatar';
import LanguageSelector from './language-selector';
function logout() {
    UserActionCreators.logout();
}
const isShipper = () => {
    return SessionStore.isShipper();
};
const isMasterAccountUser = () => {
    return SessionStore.isMasterAccountUser();
};
class ShipperNavigation extends React.Component {
    constructor(props) {
        super(props);
        this.renderMobileNav = (onClose) => {
            const items = [];
            const { t } = this.props;
            if (!isMasterAccountUser()) {
                items.push(React.createElement(NavLink, { className: "nav-item", to: "/quotes", onClick: onClose, key: "mobile-quotes" },
                    React.createElement("span", null, t('GET_QUOTE_SHIPMENT'))));
                items.push(React.createElement(NavLink, { className: "nav-item", to: "/booking", onClick: onClose, key: "mobile-booking" },
                    React.createElement("span", null, t('BOOK_SHIPMENT'))));
            }
            items.push(React.createElement(NavLink, { className: "nav-item", to: "/shipments", onClick: onClose, key: "mobile-shipments" },
                React.createElement("span", null, t('SHIPMENT_HISTORY'))));
            if (!isMasterAccountUser()) {
                items.push(React.createElement(NavLink, { className: "nav-item", to: "/invoices", onClick: onClose, key: "mobile-invoices" },
                    React.createElement("span", null, t('MY_INVOICES'))));
            }
            if (isShipper()) {
                items.push(React.createElement(NavLink, { className: "nav-item", to: "/accessorials", onClick: onClose, key: "mobile-accessorials" },
                    React.createElement("span", null, t('ACCESSORIAL', { count: 2 }))));
            }
            items.push(React.createElement(NavLink, { className: "nav-item", to: "/profile", onClick: onClose, key: "mobile-profile" },
                React.createElement("span", null, titleize(t('PROFILE', { count: 1 })))));
            items.push(React.createElement("div", { key: "language-selector-mobile", className: classNames('flex items-center justify-center nav-item', {
                    hidden: LANGUAGE_SELECTION_DISABLED,
                }) },
                React.createElement(LanguageSelector, { mobile: true })));
            items.push(React.createElement("a", { href: "#", className: "nav-item", onClick: logout, key: "mobile-sign-out" }, t('SIGN_OUT')));
            return items;
        };
        this.renderRightNav = () => {
            const { t } = this.props;
            const shipperName = SessionStore.getUser().first_name;
            const userId = SessionStore.getUser()._id;
            const profileButton = (React.createElement("div", { title: shipperName, className: "flex text-sm bg-gray-800 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-gray-800 focus:ring-white", "aria-haspopup": "true", key: "profile-button" },
                React.createElement(Avatar, { key: userId, userId: userId, altName: "Logo", className: "w-8 h-8 rounded-full" })));
            return [
                React.createElement("div", { key: "language-selector", className: classNames('flex items-center justify-center nav-item mr-2', { hidden: LANGUAGE_SELECTION_DISABLED }) },
                    React.createElement(LanguageSelector, null)),
                React.createElement(DropdownMenu, { button: profileButton, key: "right-nav" },
                    React.createElement(Menu.Item, { key: "profile" },
                        React.createElement(NavLink, { activeClassName: "active-light", className: "nav-item", to: "/profile" },
                            React.createElement("span", null, titleize(t('MANAGE'))))),
                    React.createElement(Menu.Item, { key: "billing" },
                        React.createElement(NavLink, { activeClassName: "active-light", className: "nav-item", to: "/billing" },
                            React.createElement("span", null, t('BILLING')))),
                    React.createElement(Menu.Item, { key: "notifications" },
                        React.createElement(NavLink, { activeClassName: "active-light", className: "nav-item", to: "/notifications" },
                            React.createElement("span", null, titleize(t('NOTIFICATION', { count: 2 }))))),
                    !isMasterAccountUser() && (React.createElement(Menu.Item, { key: "invoices" },
                        React.createElement(NavLink, { activeClassName: "active-light", className: "nav-item", to: "/invoices" },
                            React.createElement("span", null, t('MY_INVOICES'))))),
                    React.createElement(Menu.Item, { key: "sign-out" },
                        React.createElement("a", { href: "#", onClick: logout }, t('SIGN_OUT')))),
            ];
        };
        this.state = {
            logo: CargomaticLogo,
            reports: [],
        };
    }
    componentDidMount() {
        const logoFunction = async () => {
            const logo = await WhiteLabel.getClientLogo(false);
            if (logo) {
                this.setState({ logo });
            }
        };
        getCustomerReports()
            .then((reports) => {
            this.setState({ reports });
        })
            .catch((e) => console.error(e));
        logoFunction();
    }
    renderMenuItemDashboard() {
        const { t } = this.props;
        const { reports } = this.state;
        const doesUserHaveSharedReports = reports === null || reports === void 0 ? void 0 : reports.length;
        const showDashboard = doesUserHaveSharedReports;
        if (showDashboard) {
            return (React.createElement(Menu.Item, { key: "dashboard-item" },
                React.createElement(NavLink, { activeClassName: "active-light", className: "nav-item", to: "/unifiedview/dashboard" },
                    React.createElement("span", null, titleize(`${t('DASHBOARD')}`)))));
        }
    }
    render() {
        if (SessionStore.isQuotesOnly()) {
            return (React.createElement("div", { className: "absolute top-0 left-0 w-full", key: "tracking-header" },
                React.createElement(TrackingHeader, null)));
        }
        const brandLogo = (React.createElement(NavLink, { to: "/", key: "brand-logo" },
            React.createElement("img", { alt: "Cargomatic", src: this.state.logo, style: { height: 25 } })));
        const overlay = (React.createElement(NavbarOverlayBanner, { text: SessionStore.getUser().company_name || '', showButton: true, key: "overlay-banner" }));
        const isLoggedInAs = !!SessionStore.getLoginAs();
        const { t } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement(Navbar, { logo: brandLogo, renderRightNav: this.renderRightNav, renderMobileNav: this.renderMobileNav },
                React.createElement(DropdownMenu, { title: t('SHIPMENT', { count: 2 }), isDark: true, dropDownButtonWidth: "w-16" },
                    !isMasterAccountUser() && (React.createElement(React.Fragment, null,
                        this.renderMenuItemDashboard(),
                        React.createElement(Menu.Item, { key: "quotes-menu-item" },
                            React.createElement(NavLink, { activeClassName: "active-light", className: "nav-item", to: "/quotes" },
                                React.createElement("span", null, t('GET_QUOTE_SHIPMENT')))),
                        React.createElement(Menu.Item, { key: "booking-nav-item" },
                            React.createElement(NavLink, { activeClassName: "active-light", className: "nav-item", to: "/booking" },
                                React.createElement("span", null, t('BOOK_SHIPMENT')))))),
                    React.createElement(Menu.Item, { key: "shipments-nav-item" },
                        React.createElement(NavLink, { activeClassName: "active-light", className: "nav-item", to: "/shipments" },
                            React.createElement("span", null, t('SHIPMENT_HISTORY'))))),
                !isMasterAccountUser() && (React.createElement(NavLink, { className: "nav-item", to: "/invoices", key: "my-invoices-menu-item" },
                    React.createElement("span", null, t('MY_INVOICES')))),
                isShipper() && (React.createElement(NavLink, { className: "nav-item", to: "/accessorials", key: "accessorials-nav-item" },
                    React.createElement("span", null, t('ACCESSORIAL', { count: 2 })))),
                React.createElement("div", { className: "min-w-full flex flex-row items-center justify-end", key: "shipment-search" },
                    React.createElement("div", { className: "w-60" },
                        React.createElement(ShipmentSearch, null)))),
            React.createElement("div", { key: "overlay-item" }, isLoggedInAs && overlay)));
    }
}
export default withTranslation()(ShipperNavigation);
